import angular from 'angular';
import uiRouter from 'angular-ui-router';

export const FooterDirectiveModule = angular.module('acme.common.directive.footer', [
  uiRouter
])
.directive('footer', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/footer/footer.tpl.html',
      scope: {
        hidePrivacyPolicy: '=',
        showCaptchaPrivacyPolicy: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$state', function($scope, $state) {

        $scope.footer = {

          tenantId: 0,

          init: function() {
            this.tenantId = $state.params.tenantId;
          }

        };

        $scope.footer.init();

      }]

    };

}]).name;
